// extracted by mini-css-extract-plugin
module.exports = {"active":"NavigationIcon_active__UATy-","inactive":"NavigationIcon_inactive__1OE3q"};